import styled from '@mui/material/styles/styled'
import Tab from '@mui/material/Tab'

export const TabStyled = styled(Tab, {
  name: 'TabStyled',
  shouldForwardProp: (prop) => prop !== 'color',
})(({ color }) => ({
  color,
  fontFamily: 'Source Sans Pro Semibold',
  flex: 1,
  whiteSpace: 'nowrap',
}))
